// src/App.js
import React from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import FeaturesRow from "./components/FeaturesRow";
import Inspiration from "./components/Inspiration";
import Beautify from "./components/Beautify";
import BrowseRange from "./components/BrowseRange";
import HowItWorks from "./components/HowItWorks";
import MailingList from "./components/MailingList";
import Footer from "./components/Footer";

export default function App() {
  return (
    <div className="min-h-screen bg-gray-100">
      {/* Navbar */}
      <Navbar />

      {/* Hero Section */}
      <Hero />
      <FeaturesRow />
      <Inspiration />
      <Beautify />
      <BrowseRange /> 
      <HowItWorks />
      <MailingList />
     
      {/* Footer Section */}

      <Footer />

    </div>
  );
}
